import { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { Helmet } from 'react-helmet'
// import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.css'
import { getDoc, doc } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
import { db } from '../firebase.config'
import Spinner from '../components/Spinner'
import shareIcon from '../assets/svg/shareIcon.svg'
import { useRef } from 'react'; // Add this import statement
import { ReactComponent as PositionIcon } from '../assets/svg/positionIcon.svg'
import { ReactComponent as CompanyIcon } from '../assets/svg/companyIcon.svg'
import { ReactComponent as LocationIcon } from '../assets/svg/locationIcon.svg'
import { ReactComponent as IndustryIcon } from '../assets/svg/industryIcon.svg'
import { Link } from 'react-router-dom'





function Listing() {
  const [listing, setListing] = useState(null)
  const [loading, setLoading] = useState(true)
  const [shareLinkCopied, setShareLinkCopied] = useState(false)

  const navigate = useNavigate()
  const params = useParams()
  const auth = getAuth()

  // const swiperRef = useRef(null); // Add this useRef hook

  useEffect(() => {
    const fetchListing = async () => {
      const docRef = doc(db, 'listings', params.listingId)
      const docSnap = await getDoc(docRef)

      if (docSnap.exists()) {
        setListing(docSnap.data())
        setLoading(false)
      }
    }

    fetchListing()
  }, [navigate, params.listingId])

  if (loading) {
    return <Spinner />
  }

  if (!listing) {
    return null; // Handle the case when listing is null
  }

  return (
    <main className='listingbackground'>
      <Helmet>
        <title>{listing.title}</title>
      </Helmet>
      {/* <Swiper autoplay={{ delay: 1000 }}
        navigation  // Add the navigation prop
        pagination={{ clickable: true }}
        slidesPerView={1}
        onSwiper={(swiper) => {
          swiperRef.current = swiper; // Save the swiper instance in the ref
        }}
      > */}
      {/* {listing.imgUrls.map((url, index) => (
          <SwiperSlide key={index}>
            <div
              style={{
                background: `url(${listing.imgUrls[index]}) center no-repeat`,
                backgroundSize: 'cover',
              }}
              className='swiperSlideDiv'
            ></div>
          </SwiperSlide>
        ))} */}
      {/* </Swiper> */}


      <div
        className='shareIconDiv'
        onClick={() => {
          navigator.clipboard.writeText(window.location.href)
          setShareLinkCopied(true)
          setTimeout(() => {
            setShareLinkCopied(false)
          }, 2000)
        }}
      >
        <img src={shareIcon} alt='' />
      </div>

      {shareLinkCopied && <p className='linkCopied'>Linku u kopjua</p>}

      <div className='listingDetails'>

        <div className='image-container'>
          {listing && listing.imgUrls && Array.isArray(listing.imgUrls) ? (
            listing.imgUrls.map((url, index) => (
              <div key={index} className='swiperSlideDiv'>
                <a href={(listing.imgUrls[index])} target="_blank" rel="noopener noreferrer">
                  <div
                    className="image-wrapper"
                    style={{
                      width: '200px', // Set the desired width for your container
                      height: '200px', // Set the desired height for your container
                      overflow: 'hidden', // Ensure that any overflowing content is hidden
                    }}
                  >
                    <img
                      src={listing.imgUrls[index]}
                      alt={`fot`}
                      style={{
                        width: '100%', // Ensure the image fills the container horizontally
                        height: 'auto', // Allow the height to adjust automatically to maintain aspect ratio
                      }}
                    />
                  </div>
                </a>
              </div>
            ))
          ) : (
            <div>No media available</div>
          )}
        </div>

        <p className='listingName'>
          {/* {listing && listing.kompania && (
            <>
              {listing.kompania}
            </>
          )} */}
        </p>

        <div className='toplisting'>
          <div className='listing1'>
            <p className='positionicon'> {listing.kompania} </p>
            <h2 className='mainpozita'> {listing.pozita} </h2>
          </div>
          <div className='listing1'>
            <p> Numri i pozitave: {listing.nripozitave} </p>
            <p className='positionicon'>Lokacioni: {listing.vendndodhja} </p>
            <p className='dataeskadimit'> Data e Fundit: {listing.dataeskadimit} </p>
          </div>
        </div>


        <h4 className='maindetyrat'> Detyrat dhe Përgjegjësite</h4>
        <p className='formatted-text'> {listing.detyrat} </p>
        <h4 className='maindetyrat'> Kualifikimet e kërkuara</h4>
        <p className='formatted-text'> {listing.kualifikimet} </p>
        <h4 className='maindetyrat'>Shënime</h4>
        <p className='formatted-text'> {listing.shenime} </p>

        {/* <div className="formatted-text">
          {listing && typeof listing.text === 'string' ? (
            <div>{listing.text}</div>
          ) : (
            <div>No text available</div>
          )}
        </div> */}


      </div >

      {/* <Helmet>
        <title>{listing.name}</title>
        <meta property="og:title" content={listing.name} />
        <meta property="og:description" content={listing.location} />
        <meta property="og:image" content={listing.imgUrls[0]} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="shpiza.com" />
      </Helmet> */}
    </main>
  )
}

export default Listing

// https://stackoverflow.com/questions/67552020/how-to-fix-error-failed-to-compile-node-modules-react-leaflet-core-esm-pat